// extracted by mini-css-extract-plugin
export default {"root":"Nf1G_","text":"_1fFDp","activity":"_2-5Bk"};